import {gql, useApolloClient} from '@apollo/client';
import {useCallback} from 'react';
import {SubmittedRequestType as RequestType} from "../../submitted-request/SubmittedRequestDomain";
import {ValidationResult} from "../../domain";

import {
    CHECK_SUBMITTED_REQUESTS,
    CheckSubmittedRequestsResponse,
    submittedRequestValidationMessage
} from "../../submitted-request/SubmittedRequestOpenCaseQuery";


function validateNoContactResponse(data: CheckSubmittedRequestsResponse): ValidationResult {
    if (!data) {
        return {status: false, message: 'Error! No data returned from server'};
    }

    if (data.openCaseSubmitRequestQuery.length > 0) {
        const first = data.openCaseSubmitRequestQuery[0];
        const requestType = RequestType[first.requestType as keyof typeof RequestType];
        return {
            status: false,
            message: submittedRequestValidationMessage(RequestType.No_Contact, requestType, first.caseNumber)
        };
    }

    return {status: true, message: 'Pass!'};
}

export const useNoContactValidation = () => {
    const client = useApolloClient();
    const validateNoContact = useCallback(async (authorizationGuid?: string): Promise<ValidationResult> => {
        if (!authorizationGuid) {
            return {status: false, message: 'No authorizationGuid'};
        }
        return client.query<CheckSubmittedRequestsResponse>({
            query: CHECK_SUBMITTED_REQUESTS,
            variables: {
                authorizationGuid: authorizationGuid,
                requestTypes: ["Treatment_Hold", "No_Contact", "Client_Return_Transfer_Request"]
            },
            fetchPolicy: 'network-only',
        }).then(({data}) => validateNoContactResponse(data));
    }, [client]);

    return {validateNoContact};
};
